export default{
    msg:'',
    editar:{},
    lista:'',
    boletins:'',
    horarios:''
}